import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, of, switchMap, tap, throwError } from 'rxjs';
import { AuthService } from './auth.service';
import { SessionStorageService } from './session-storage.service';

const SESSION_CLIENT = 'CUSTOMER_PORTAL';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const storage = inject(SessionStorageService);
  const auth = inject(AuthService);
  const router = inject(Router);

  const token = storage.getAccessToken();
  const attach = (accessToken: string | null) => {
    let headers = req.headers
      .set('X-Cargomate-Session-Id', storage.ensureBrowserSessionId())
      .set('X-Cargomate-Session-Client', SESSION_CLIENT);

    const scope = storage.getPortalScope();
    if (scope.accessId != null) {
      headers = headers.set('X-Cargomate-Portal-Access-Id', String(scope.accessId));
    } else if (scope.tenantCompanyId != null) {
      headers = headers.set('X-Cargomate-Tenant-Company-Id', String(scope.tenantCompanyId));
    }

    if (accessToken) {
      headers = headers.set('Authorization', `Bearer ${accessToken}`);
    }

    return req.clone({ headers });
  };

  return next(attach(token)).pipe(
    catchError(error => {
      if (error.status === 401 && error?.error?.code === 'SESSION_REPLACED') {
        return auth.logout().pipe(
          catchError(() => of(undefined)),
          tap(() => void router.navigate(['/login'])),
          switchMap(() => throwError(() => error))
        );
      }
      if (error.status !== 401 || !token) {
        return throwError(() => error);
      }
      return auth.getCurrentUserToken().pipe(
        switchMap(refreshedToken => next(attach(refreshedToken))),
        catchError(refreshError => throwError(() => refreshError))
      );
    })
  );
};
